import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { Navigate, useNavigate } from 'react-router';
import { ArticleCreate, OrgCreate, ResourceCreate } from '../../api/orgService';
import SubCategorySelect from '../Admin/Consumer/SubCategorySelect';
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from "@mui/icons-material/Upload";
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const ResourceCreateForm = ({allTopics,allSubtopics,setSelected}) => {
    const navigate = useNavigate()

    const [tabIndex, setTabIndex] = useState(0); // 0 = Link, 1 = Upload
    const [fileUpload,setConstFileUpload] = useState(false)
    const fileInputRef = useRef(null);

  const [form, setForm] = useState({
    title: '',
    description: '',
    publisher: '',
    file_path:"",
    sub_category:0,
  });

  const [loadFile,setLoadFile]=useState(false)

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createResource,data:createResourceData,error:createResourceError,isLoading:createResourceIsLoading}=useApi(ResourceCreate)


  const handleChange = (e) => {
    // setForm({ ...form, [e.target.name]: e.target.value });
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 

  useEffect(()=>{
    if(createResourceData){
      if(createResourceData?.status===201){
        toast.success(`${JSON.stringify(createResourceData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        navigate("/staff/resources/",{state: {redirect:"list-resources"}})
      }
    }
  },[createResourceData])

  useEffect(()=>{
    if(createResourceError){

        toast.error(`${JSON.stringify(createResourceError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createResourceError])

  const  okayToSubmit =  !form.title?.length>0 || !form.description?.length>0 || !form.file_path?.length>0 || !form.sub_category===0

  const handleSetSubCategoryId = (subcategoryId)=>{
    // console.log(subcategoryId)
    // setForm({ ...form, sub_category: parseInt(subcategoryId) })
    setForm(prev => ({
      ...prev,
      sub_category: parseInt(subcategoryId)
    }));
    // console.log(form)
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file){
    const previewUrl = URL.createObjectURL(file);
    setForm((prev) => ({ ...prev, value: previewUrl }));


    const formData = new FormData();
    formData.append("image", file);
    setConstFileUpload(true)
    try{
      // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
      // const res = await fetch("https://178.128.35.136/cms/ftp-files/", {
        const res = await fetch("/cms/ftp-files/", {
        method: "POST",
        body: formData, // don't add headers here
      });
    // console.log(res)
    if(res?.status===201){
      let result = await res.json()
    //   console.log("Upload urls: ",result)
      setForm((prevData)=>({
        ...prevData,
        file_path: result?.path,
      }));
    // setMaterialUrl(event,event.target.value)
      // setUploadUrls(prev=>res?.data)
      setConstFileUpload(false)
    }else{
      console.log(res)
    }
    }catch(error){
      console.log(error)
    }

    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Material Created:', form);
    form.publisher= user?.user?.id
    const dataToSend = {
    //   publisher:form.created_by,
    publisher:form.publisher,
    title:form.title,
    description:form.description,
    sub_category:form.sub_category,
    file_path:form.file_path
    }
    createResource(dataToSend)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Resource
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          A Resource is used to publish any documentation information about the organisation 
          activities, projects, posts, <br/>news and campaigns. Use resources as an explainer to put more details  about the organisation.

          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>

            <TextField
              fullWidth
              label="Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            
            <Typography variant='p' component="p" color='#404040'>
            Write a brief summary statement or description that explains about the main point point of the article.
            </Typography>
           
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={form.description}
              onChange={handleChange}
              margin="normal"
              required
            />

            <SubCategorySelect setSubCategoryId={handleSetSubCategoryId}/>

            <>
                <Tabs
                value={tabIndex}
                onChange={(e, newValue) => setTabIndex(newValue)}
                centered
                sx={{ mb: 1 }}
                >
                <Tab label="File Link" />
                <Tab label="Select File & Upload" />
                </Tabs>

                {tabIndex === 0 ? (
                <TextField
                    name="file_path"
                    label= "File Path or Link"
                    value={form.file_path}
                    onChange={handleChange}
                    fullWidth
                />
                ) : (
                <Box
                    sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                    }}
                >
                    {form.file_path ? (
                    form.file_path?.length >= 0 ? (
                        (
                            <>
                              {form.file_path.endsWith(".pdf") ? (
                                // --- PDF Preview ---
                                <iframe
                                  src={form.file_path}
                                  title="PDF Preview"
                                  style={{
                                    width: "100%",
                                    height: "400px",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    marginBottom: "8px",
                                  }}
                                />
                              ) : form.file_path.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
                                // --- Image Preview ---
                                <img
                                  src={form.file_path}
                                  alt="preview"
                                  style={{
                                    width: "100%",
                                    borderRadius: "8px",
                                    marginBottom: "8px",
                                  }}
                                />
                              ) : (
                                // --- File (non-image, non-PDF) ---
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                    padding: "20px",
                                    backgroundColor: "#fafafa",
                                    color: "#555",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <span style={{ fontSize: "48px" }}>📄</span>
                                  <p>{form.file_path.split("/").pop()}</p>
                                  <a
                                    href={form.file_path}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      textDecoration: "none",
                                      color: "#1976d2",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Open File
                                  </a>
                                </div>
                              )}
                            </>
                          )
                    ) : (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                        File selected: {form.file_path.split("/").pop()}
                        </Typography>
                    )
                    ) : (
                    <UploadIcon sx={{ fontSize: 50, color: "#aaa", mb: 1 }} />
                    )}

                    <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current.click()}
                    loading={fileUpload}
                    >
                    {form.value ? "Change File" : "Upload File"}
                    </Button>
                    <input
                    type="file"
                    accept={"*/*"}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    />
                </Box>
                )}
            </>

            {/* <TextField
              fullWidth
              label="Organisation tag Name"
              name="org_tag"
              value={form.subcategory}
              onChange={handleChange}
              margin="normal"
              required
            /> */}

            {/* <TextField
              fullWidth
              label="Organisation tag Name"
              name="org_tag"
              value={form.category}
              onChange={handleChange}
              margin="normal"
              required
            /> */}
            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Create Resource
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default ResourceCreateForm